// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview {
    width: 50px;
    height: 50px;
    border: 2px solid var(--appbuilder-primary-color);
    border-radius: 6px;
    align-self:center;
    margin:auto;
}
.selected-entry-wrapper {
    display: grid;
    grid-template-rows: auto 104px auto auto;
    grid-template-columns: 1fr 1fr;
    grid-column-start:1;
    grid-column-end:3;
}
.shift-right{
    grid-row-start:2;
    grid-row-end:3;
    grid-column-start:2;
    grid-column-end:3;
    padding:5px;
    display:flex;
    flex-direction:column;
    align-self:center;
}
.shift-down {
    grid-row-start: 3;
    grid-row-end: 4;
    grid-column-start: 1;
    grid-column-end: 2;
    padding: 5px;
    display: flex;
    flex-direction: column;
}
.blur {
    grid-row-start: 4;
    grid-row-end: 5;
    grid-column-start: 1;
    grid-column-end: 3;
    padding: 5px;
    display: flex;
    flex-direction: column;
}
.spread {
    grid-row-start: 3;
    grid-row-end: 4;
    grid-column-start: 2;
    grid-column-end: 3;
    padding: 5px;
    display: flex;
    flex-direction: column;
}
.opacity {
    grid-row-start: 1;
    grid-row-end: 2;
    grid-column-start: 2;
    grid-column-end: 3;
    padding: 5px;
    display: flex;
    flex-direction: column;
}
.color {
    grid-row-start: 1;
    grid-row-end: 2;
    grid-column-start: 1;
    grid-column-end: 2;
    padding: 5px;
    display: flex;
    flex-direction: column;
}
.item-preview {
    width: 50px;
    height: 50px;
    border: 2px solid var(--appbuilder-primary-color);
    border-radius: 6px;
    align-self: center;
    margin: auto;
    grid-row-start: 2;
    grid-row-end: 3;
    grid-column-start: 1;
    grid-column-end: 2;
}`, "",{"version":3,"sources":["webpack://./src/app/appbuilder/controls/boxshadow/boxshadow.theme.control.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,iDAAiD;IACjD,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;AACf;AACA;IACI,aAAa;IACb,wCAAwC;IACxC,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,WAAW;IACX,YAAY;IACZ,iDAAiD;IACjD,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,kBAAkB;AACtB","sourcesContent":[".preview {\n    width: 50px;\n    height: 50px;\n    border: 2px solid var(--appbuilder-primary-color);\n    border-radius: 6px;\n    align-self:center;\n    margin:auto;\n}\n.selected-entry-wrapper {\n    display: grid;\n    grid-template-rows: auto 104px auto auto;\n    grid-template-columns: 1fr 1fr;\n    grid-column-start:1;\n    grid-column-end:3;\n}\n.shift-right{\n    grid-row-start:2;\n    grid-row-end:3;\n    grid-column-start:2;\n    grid-column-end:3;\n    padding:5px;\n    display:flex;\n    flex-direction:column;\n    align-self:center;\n}\n.shift-down {\n    grid-row-start: 3;\n    grid-row-end: 4;\n    grid-column-start: 1;\n    grid-column-end: 2;\n    padding: 5px;\n    display: flex;\n    flex-direction: column;\n}\n.blur {\n    grid-row-start: 4;\n    grid-row-end: 5;\n    grid-column-start: 1;\n    grid-column-end: 3;\n    padding: 5px;\n    display: flex;\n    flex-direction: column;\n}\n.spread {\n    grid-row-start: 3;\n    grid-row-end: 4;\n    grid-column-start: 2;\n    grid-column-end: 3;\n    padding: 5px;\n    display: flex;\n    flex-direction: column;\n}\n.opacity {\n    grid-row-start: 1;\n    grid-row-end: 2;\n    grid-column-start: 2;\n    grid-column-end: 3;\n    padding: 5px;\n    display: flex;\n    flex-direction: column;\n}\n.color {\n    grid-row-start: 1;\n    grid-row-end: 2;\n    grid-column-start: 1;\n    grid-column-end: 2;\n    padding: 5px;\n    display: flex;\n    flex-direction: column;\n}\n.item-preview {\n    width: 50px;\n    height: 50px;\n    border: 2px solid var(--appbuilder-primary-color);\n    border-radius: 6px;\n    align-self: center;\n    margin: auto;\n    grid-row-start: 2;\n    grid-row-end: 3;\n    grid-column-start: 1;\n    grid-column-end: 2;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
